export default __webpack_public_path__ + "static/Mailchimp-943beaa0b29086c36c6fb479a8b48055.svg";